import CMText from '@src/components/Atoms/CMText';
import ModalContainer from '@src/components/Molecules/ModalContainer';
import { theme } from '@src/styles/theme';
import React from 'react';
import { AiOutlineClose } from 'react-icons/ai';
import { IoChatbubbleEllipsesOutline } from 'react-icons/io5';
import styled from 'styled-components';

/**
 * 채팅 시작 확인 모달. 앱(pple-flutter story_pre_view.dart)의 "수혈자와 채팅을 시작합니다"
 * 바텀시트를 웹으로 이식 — 아이콘 + 제목 + 주의문구 + "채팅 시작하기" 버튼.
 */
type Props = {
  onClose: () => void;
  onConfirm: () => void;
  stopPropagation: (e: any) => void;
  isLoading?: boolean;
};

const ChatStartModal = ({
  onClose,
  onConfirm,
  stopPropagation,
  isLoading,
}: Props) => {
  return (
    <ModalContainer
      width={420}
      height={360}
      onClose={onClose}
      stopPropagation={stopPropagation}
      backgroundColor={theme.commonColor.white}
    >
      <Container>
        <CloseButton onClick={onClose} />
        <IconCircle>
          <ChatIcon />
        </IconCircle>
        <Title fontSize={22} fontWeight={700}>
          수혈자와 채팅을 시작합니다
        </Title>
        <Caution>
          서로에게 불쾌감을 주는 내용과
          <br />
          개인정보 이야기는 삼가해주세요!
        </Caution>
        <StartButton onClick={onConfirm} disabled={isLoading}>
          {isLoading ? '채팅방 여는 중…' : '채팅 시작하기'}
        </StartButton>
      </Container>
    </ModalContainer>
  );
};

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  padding: 24px 32px 32px;
  position: relative;
`;

const CloseButton = styled(AiOutlineClose)`
  width: 24px;
  height: 24px;
  margin-left: auto;
  color: ${({ theme }) => theme.commonColor.gray006};
  cursor: pointer;
  position: absolute;
  top: 16px;
  right: 16px;
`;

const IconCircle = styled.div`
  width: 84px;
  height: 84px;
  border-radius: 50%;
  background-color: ${({ theme }) => theme.commonColor.pink001};
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 12px;
`;

const ChatIcon = styled(IoChatbubbleEllipsesOutline)`
  width: 42px;
  height: 42px;
  color: ${({ theme }) => theme.commonColor.pink004};
`;

const Title = styled(CMText)`
  margin-top: 20px;
  text-align: center;
  color: ${({ theme }) => theme.commonColor.black};
`;

const Caution = styled.p`
  margin-top: 14px;
  font-size: 15px;
  font-weight: 700;
  line-height: 22px;
  letter-spacing: -0.6px;
  text-align: center;
  color: ${({ theme }) => theme.commonColor.gray007};
`;

const StartButton = styled.button`
  margin-top: 24px;
  width: 100%;
  max-width: 260px;
  padding: 15px 0;
  border: none;
  border-radius: 15px;
  background-color: ${({ theme }) => theme.commonColor.pink004};
  color: ${({ theme }) => theme.commonColor.white};
  font-size: 17px;
  font-weight: 700;
  letter-spacing: -0.6px;
  cursor: pointer;

  &:disabled {
    background-color: ${({ theme }) => theme.commonColor.gray003};
    cursor: default;
  }
`;

export default ChatStartModal;
